import React from "react";
import { Zap, Smartphone, BadgeCheck, CalendarCheck } from "lucide-react";

const items = [
  { icon: Zap, label: "Fast Response" },
  { icon: Smartphone, label: "Mobile Convenience" },
  { icon: BadgeCheck, label: "Professional Service" },
  { icon: CalendarCheck, label: "Easy Scheduling" },
];

export const TrustBar = ({ variant = "card" }) => {
  if (variant === "strip") {
    return (
      <section
        className="border-y bg-white"
        style={{ borderColor: "#E2E8F0" }}
        data-testid="trust-strip"
      >
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-5 sm:py-6">
          <ul className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4">
            {items.map(({ icon: Icon, label }) => (
              <li key={label} className="flex items-center gap-3">
                <span
                  className="grid place-items-center h-9 w-9 rounded-full shrink-0"
                  style={{ background: "rgba(212,175,55,0.12)" }}
                >
                  <Icon className="h-4 w-4" style={{ color: "#D4AF37" }} strokeWidth={2.4} />
                </span>
                <span
                  className="text-sm font-semibold tracking-tight"
                  style={{ color: "#0B2545" }}
                >
                  {label}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    );
  }
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-4 gap-3"
      data-testid="trust-bar"
    >
      {items.map(({ icon: Icon, label }) => (
        <div
          key={label}
          className="flex items-center gap-2 rounded-md border bg-white px-3 py-2.5"
          style={{ borderColor: "#E2E8F0" }}
        >
          <Icon className="h-4 w-4" style={{ color: "#D4AF37" }} strokeWidth={2.2} />
          <span className="text-xs font-medium" style={{ color: "#0B2545" }}>
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustBar;
